export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 14;
export const KEY = '0959c549-d92f-4dc8-a37a-5de1accba128';
export const MODEL_CLOSE_SEC = 2.5;
